<template>
  <CustomTable
    title="Привязка параметров этажа с параметром планировки"
    :rowsData="data"
    :columns="paramLinkColumns"
    :loading="loading"
    :show-search="true"
    :custom-body="true"
    :sticky-header="true"
    :showHeaderAdd="true"
    :on-add-click="addNewItem"
  >
    <template #customBody="props">
      <q-tr>
        <custom-table-cell align="center">
          {{ props.row.floor_param_type_param_link_id }}
        </custom-table-cell>

        <custom-table-cell align="left">
          <CustomSelect
            v-if="editingId === props.row.floor_param_type_param_link_id"
            :key="`floor-param-${props.row.floor_param_type_param_link_id}`"
            :options="floorParamTypesOptions"
            :value="editForm.floor_param_type_id"
            @change="(value) => editForm.floor_param_type_id = value"
            label="Выберите параметр этажа"
            optionValueKey="floor_param_type_id"
            optionLabelKey="floor_param_type_name"
            :clearable="false"
            :required="true"
          />
          <span v-else>{{ props.row.floor_param_type_name }}</span>
        </custom-table-cell>

        <custom-table-cell align="left">
          <CustomSelect
            v-if="editingId === props.row.floor_param_type_param_link_id"
            :key="`param-${props.row.floor_param_type_param_link_id}`"
            :options="paramsOptions"
            :value="editForm.param_id"
            @change="(value) => editForm.param_id = value"
            label="Выберите параметр планировки"
            optionValueKey="param_id"
            optionLabelKey="param_name"
            :clearable="false"
            :required="true"
          />
          <span v-else>{{ props.row.param_name }}</span>
        </custom-table-cell>

        <custom-table-cell align="center" style="justify-items: center">
          <div class="action-buttons">
            <button
              v-if="editingId === props.row.floor_param_type_param_link_id"
              @click="saveItem"
              class="btn btn-success btn-sm"
              :disabled="saving"
            >
              Сохранить
            </button>
            <button
              v-if="editingId === props.row.floor_param_type_param_link_id"
              @click="cancelEdit"
              class="btn btn-secondary btn-sm"
            >
              Отмена
            </button>
            <button
              v-else
              @click="editItem(props.row)"
              class="btn btn-primary btn-sm"
            >
              Редактировать
            </button>
          </div>
        </custom-table-cell>
        <custom-table-cell align="center" vertical-align="center">
          <CustomIcon
            icon="trash"
            :approve-mode="true"
            :loading="!!deleteLoading[props.row.floor_param_type_param_link_id]"
            :approve="() => onDeleteSubmit(props.row.floor_param_type_param_link_id)"
          />
        </custom-table-cell>
      </q-tr>
    </template>
  </CustomTable>
</template>

<script>
import { getParamLinks, updateParamLink, getFloorParamTypesForSelect, getParams, paramLinkColumns, deleteParamLink } from "./services";
import CustomTable from '@/components/common/CustomTable/index.vue'
import CustomTableCell from '@/components/common/CustomTable/custom-table-cell'
import CustomSelect from '@/components/form/CustomSelect'
import CustomIcon from '@/components/common/CustomIcon'

export default {
  name: "ParamLink",
  components: {
    CustomTable,
    CustomTableCell,
    CustomSelect,
    CustomIcon
  },
  data() {
    return {
      data: [],
      loading: false,
      saving: false,
      editingId: null,
      editForm: {
        floor_param_type_param_link_id: null,
        floor_param_type_id: null,
        param_id: null,
      },
      floorParamTypesOptions: [],
      paramsOptions: [],
      paramLinkColumns,
      deleteLoading: {},
      deleting: false,
    };
  },
  async mounted() {
    await this.loadData();
    await this.loadOptions();
  },
  methods: {
    async loadData() {
      this.loading = true;
      const result = await getParamLinks();
      this.loading = false;
      if (!result) return;
      this.data = (result || []).map((item, index) => ({
        ...item,
        _uniqueKey: `${item.floor_param_type_id}-${item.param_id}-${index}`,
      }));
    },

    async loadOptions() {
      const [floorParamTypesResult, paramsResult] = await Promise.all([
        getFloorParamTypesForSelect(),
        getParams(),
      ]);
      if (!floorParamTypesResult || !paramsResult) return;
      this.floorParamTypesOptions = floorParamTypesResult || [];
      this.paramsOptions = paramsResult || [];
    },

    editItem(item) {
      this.editingId = item.floor_param_type_param_link_id;
      this.editForm = { ...item };
    },

    addNewItem() {
      if (this.editingId !== null) {
        return;
      }
      const newItem = {
        floor_param_type_param_link_id: 0,
        floor_param_type_id: null,
        param_id: null,
      };
      this.data.unshift(newItem);
      this.editItem(newItem);
    },

    async saveItem() {
      if (!this.editForm.floor_param_type_id) {
        this.$q.notify({
          type: 'negative',
          message: 'Параметр этажа обязателен для выбора'
        });
        return;
      }
      if (!this.editForm.param_id) {
        this.$q.notify({
          type: 'negative',
          message: 'Параметр планировки обязателен для выбора'
        });
        return;
      }

      this.saving = true;
      const result = await updateParamLink(this.editForm);
      this.saving = false;
      if (!result) return;
      this.cancelEdit();
      await this.loadData();
    },

    cancelEdit() {
      if (this.editForm.floor_param_type_param_link_id === 0) {
        this.data = this.data.filter(item => item.floor_param_type_param_link_id !== 0);
      }
      this.editingId = null;
      this.resetEditForm();
    },

    resetEditForm() {
      this.editForm = {
        floor_param_type_param_link_id: null,
        floor_param_type_id: null,
        param_id: null,
      };
    },
    async onDeleteSubmit(floor_param_type_param_link_id) {
      if (this.deleteLoading[floor_param_type_param_link_id]) return;
      this.deleting = true;
      this.deleteLoading = { ...this.deleteLoading, [floor_param_type_param_link_id]: true };
      const res = await deleteParamLink(floor_param_type_param_link_id);
      this.deleteLoading = { ...this.deleteLoading, [floor_param_type_param_link_id]: false };
      this.deleting = false;
      if (!res) return;
      this.data = this.data.filter(row => row.floor_param_type_param_link_id !== floor_param_type_param_link_id);
    },
  },
};
</script>

<style scoped>
.form-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
}

.form-control:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background-color: #0056b3;
}

.btn-success {
  background-color: #28a745;
  color: white;
}

.btn-success:hover:not(:disabled) {
  background-color: #1e7e34;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover:not(:disabled) {
  background-color: #545b62;
}

.btn-sm {
  padding: 4px 8px;
  font-size: 12px;
}
</style>
